<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
		:style="getWrapperStyle(node)"
	>

		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<nav class="navbar navbar-expand-lg navbar-light" :style="getContainerStyle(node)">
			<a
				class="navbar-brand"
				:href="node.options.link"
				:target="node.options.inNewTab ? '_blank' : '_self'">
				<template v-if="node.options.src && node.options.src !== ''">
					<img :src="node.options.src" alt="" :style="getImageStyle(node)">
				</template>
				<template v-else>
					{{ node.options ? node.options.title : 'Navbar Title' }}
				</template>
			</a>
			<button
				class="navbar-toggler"
				type="button"
				data-toggle="collapse"
				data-target="#navbarContent"
				aria-controls="navbarContent"
				aria-expanded="false"
				aria-label="Toggle navigation"
			>
				<span class="navbar-toggler-icon"></span>
			</button>

			<div class="collapse navbar-collapse" id="navbarContents">
				<ul class="navbar-nav ml-auto">
					<template v-if="node.options.items && node.options.items.length">
						<li class="nav-item" v-for="(item, i) in node.options.items" :key="i">
							<a class="nav-link" :href="item.link || '#'" :style="getFontStyle(node)">{{ item.content }}</a>
						</li>
					</template>
				</ul>
			</div>
		</nav>
	</div>
</template>

<script>
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
import {
	// getRgbaColor,
	getNodeStyle,
} from '@/lib/helper';


export default {
	name: 'NodeNavigation',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
	},
	data() {
		return {
			isCollapsed: false,
		};
	},
	methods: {
		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getContainerStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'padding',
				'bg-color',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getFontStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
				'line-height',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getImageStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'max-width',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},

	},
};
</script>

<style scoped>
.section-action {
	display: none;
	top: 0;
	right: 0;
	background-color: #4c5866;
	position: absolute;
	z-index: 999;
}

.section-element:hover .section-action {
	display: flex;
	/* flex-direction: column; */
}
</style>
